import { useState } from 'react';
import { Unlink } from 'lucide-react';
import api from '../../../../utils/api';
import { PartnerEndpoints } from '../../../../utils/endpoints';
import { formatCount } from '../../../../utils/money';
import { Button, DataTable, IconButton, StatusPill, TableCard } from '../../../ui';
import AssignPansModal from '../../modals/AssignPansModal';
import ConfirmActionModal from '../../modals/ConfirmActionModal';

const PansTab = ({ subMerchant, canUpdate, onSubMerchantChange, onReload }) => {
  const [assignOpen, setAssignOpen] = useState(false);
  const [removeTarget, setRemoveTarget] = useState(null);
  const pans = subMerchant.pans ?? [];

  const handleAssign = async (selected) => {
    const { data } = await api.post(PartnerEndpoints.subMerchantPans(subMerchant.id), { pans: selected });
    onSubMerchantChange(data.data);
  };

  const handleRemove = async () => {
    await api.delete(PartnerEndpoints.subMerchantPan(subMerchant.id, removeTarget.pan));
    onReload();
  };

  const columns = [
    { key: 'pan', header: 'PAN', render: (row) => <span className="tabular-nums">{row.pan}</span> },
    { key: 'name', header: 'Name', render: (row) => row.name || '—' },
    { key: 'status', header: 'Status', align: 'center', render: (row) => <StatusPill status={row.status} /> },
  ];

  if (canUpdate) {
    columns.push({
      key: 'actions',
      header: 'Actions',
      align: 'center',
      render: (row) => (
        <IconButton
          icon={Unlink}
          label="Remove"
          tooltip="Remove this PAN from the sub-merchant"
          variant="link-danger"
          onClick={() => setRemoveTarget(row)}
        />
      ),
    });
  }

  return (
    <>
      <TableCard
        title="PANs"
        summary={{ label: 'Total', value: formatCount(pans.length) }}
        toolbar={canUpdate && <Button onClick={() => setAssignOpen(true)}>Assign PANs</Button>}
      >
        <DataTable
          columns={columns}
          rows={pans}
          rowKey={(row) => row.pan}
          serial
          empty={{
            title: 'No PANs',
            message: 'Taps on a PAN are credited to this sub-merchant once it is assigned here.',
          }}
        />
      </TableCard>

      <AssignPansModal
        isOpen={assignOpen}
        subMerchant={subMerchant}
        onClose={() => setAssignOpen(false)}
        onSubmit={handleAssign}
      />

      <ConfirmActionModal
        isOpen={Boolean(removeTarget)}
        title="Remove PAN"
        message={
          removeTarget
            ? `Remove ${removeTarget.pan} from ${subMerchant.name}? Its taps stop being credited here. Past ledger entries stay.`
            : ''
        }
        confirmLabel="Remove"
        confirmVariant="danger"
        onClose={() => setRemoveTarget(null)}
        onConfirm={handleRemove}
      />
    </>
  );
};

export default PansTab;
